import { useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Lightweight per-route fade. App-like feel without the cost of full
 * page transitions. Mobile only — desktop is unchanged.
 *
 * GPU-only (opacity), respects prefers-reduced-motion, 180ms.
 * Re-keys on pathname so React fully unmounts the previous tree (which
 * matches the existing route behaviour and keeps memory predictable).
 */
export default function PageTransition({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [key, setKey] = useState(pathname);

  useEffect(() => {
    setKey(pathname);
  }, [pathname]);

  return (
    <div key={key} className="route-fade">
      {children}
    </div>
  );
}
